import { LoadablePaint } from '@confluence/loadable';

export const ApprovalBanner = LoadablePaint({
	name: 'ApprovalBannerLoadable',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalBanner" */ '../src/BannerComponent/ApprovalBanner.tsx'
			)
		).ApprovalBanner,
});
